export default "__VITE_ASSET__BFFgjGu3__"